<template>
   <v-layout v-if="!socialLinks.length" row align-center :justify="layoutJustify" style="width: 100%; max-width: 300px; margin-top: 5px">
    <v-flex xs4>
      <!-- <a target="_blank"
        class="twitter-share-button"
        :href="`https://twitter.com/intent/tweet?text=${ShareString}`"
        data-size="large" data-show-count="false"
      >
        Tweet
      </a> -->

      <a id="tweetButton" target="_blank" :href="tweetUrl">
        <i></i>
        <span> Tweet </span>
      </a>
    </v-flex>

    <v-flex xs4>
      <a class="whatsapp-old"
        target="_blank"
        ref="TwitterLink"
        :href="`https://api.whatsapp.com/send?text=${ShareString} ${encodeURIComponent(storeUrl)}`"
      >
        <img :src="socialIcons.WHATSAPP" height="20">
        <span> Share </span>
      </a>
    </v-flex>
    <v-flex xs4 v-if="!isMobile">
      <iframe id="facebookButton"
        :src="`https://www.facebook.com/plugins/share_button.php?href=${encodeURIComponent(storeUrl)}&layout=button&size=large&appId=1475340159327832&width=77&height=28`"
        width="77"
        height="28"
        style="border:none;overflow:hidden"
        scrolling="no"
        frameborder="0"
        allowfullscreen="true"
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      ></iframe>
    </v-flex>
  </v-layout>  
  <v-layout v-else-if="socialLinks.length" row align-center :justify="layoutJustify" style="width: 100%; max-width: 300px; margin-top: 5px; flex-wrap: wrap">
    <v-flex xs2 v-for="(link, index) in socialLinks" :key="index">
      <a
        v-if="link.type"
        :class="link.type.toLowerCase()"
        :href="generateShareUrl(link.type, link.url)"
        target="_blank"
      >
        <img class="social-img" :src="getIcon(link.type)"/>
      </a>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    referralLink: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isMobile: window.innerWidth <= 600,
      socialIcons: {
        FACEBOOK: `/giftcard/img/socials/facebook.png`,
        GOOGLE: `/giftcard/img/socials/google.png`,
        TWITTER: `/giftcard/img/socials/twitter.png`,
        WHATSAPP: `/giftcard/img/socials/whatsapp.png`,
        WECHAT: `/giftcard/img/socials/wechat.png`,
        LINKEDIN: `/giftcard/img/socials/linkedin.png`,
        TIKTOK: `/giftcard/img/socials/tiktok.png`,
        YOUTUBE: `/giftcard/img/socials/youtube.png`,
        QQ: `/giftcard/img/socials/qq.png`,
        INSTAGRAM: `/giftcard/img/socials/instagram.png`
      },
      socialLinks: []
    };
  },
  computed: {
    layoutJustify() {
      const buttonCount = this.socialLinks.length;
      return buttonCount === 2 ? "flex-start" : "space-around";
    },
    tweetUrl() {
      const baseTweetUrl = 'https://twitter.com/intent/tweet?text=';
      const text = this.ShareString;
      const url = this.referralLink ? `You can try it here: ${encodeURIComponent(this.referralLink)}` : '';

      return `${baseTweetUrl}${encodeURIComponent(text)} ${url}`;
    },
    ShareString() {
      return `Enjoyed my meal at ${this.getStore.name}!`
    },
    storeUrl() {
      return this.referralLink ? this.referralLink : window.location.href;
    },
    ...mapGetters(["getStore"])
  },
  methods: {
    getIcon(type) {
      return this.socialIcons[type] || "";
    },
    generateShareUrl(type, url) {
      return url;
      // const encodedUrl = encodeURIComponent(url);
      // switch (type) {
      //   case "FACEBOOK":
      //     return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      //   case "TWITTER":
      //     return `https://twitter.com/intent/tweet?url=${encodedUrl}`;
      //   case "WHATSAPP":
      //     return `https://api.whatsapp.com/send?text=${encodedUrl}`;
      //   case "LINKEDIN":
      //     return `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`;
      //   default:
      //     return url;
      // }
    }
  },
  mounted() {
    this.socialLinks = this.getStore.socialMediaLinks
    if (!this.socialLinks.length) {
       window.twttr = (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0],
          t = window.twttr || {};

        if (d.getElementById(id))
          return t;

        js = d.createElement(s);
        js.id = id;
        js.src = "https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);

        t._e = [];
        t.ready = function(f) {
          t._e.push(f);
        };

        return t;
      }(document, "script", "twitter-wjs"));
    }
  },
  destroyed() {
    if (!this.socialLinks.length) {
      const twitterWidget = document.getElementById("twitter-wjs");
      if (twitterWidget) {
        twitterWidget.remove();
      } else {
        console.warn('Element "twitter-wjs" not found or already removed.');
      }
    }
  }
};
</script>

<style scoped>
.social-buttons a {
  display: inline-flex; 
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 0;
  border-radius: 5px;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
}

.social-img {
  margin-right: 0;
  width: 30px; 
  height: auto;
  background: white;
  padding: 2.5px;
  border-radius: 25px;
}
 #facebookButton, #tweetButton, .whatsapp {
    display: block;
    margin: auto;
  }

  #tweetButton {
    width: 77px;
    height: 28px;
    background-color: #1DA1F2;
    border-radius: 5px;

    font-size: 12px;
    color: white;
    text-decoration: none !important;
  }
  #tweetButton i {
    position: relative;
    top: 5px;
    left: 5px;
    display: inline-block;
    width: 18px;
    height: 18px;
    background: transparent 0 0 no-repeat;
    background-image: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2072%2072%22%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h72v72H0z%22%2F%3E%3Cpath%20class%3D%22icon%22%20fill%3D%22%23fff%22%20d%3D%22M68.812%2015.14c-2.348%201.04-4.87%201.744-7.52%202.06%202.704-1.62%204.78-4.186%205.757-7.243-2.53%201.5-5.33%202.592-8.314%203.176C56.35%2010.59%2052.948%209%2049.182%209c-7.23%200-13.092%205.86-13.092%2013.093%200%201.026.118%202.02.338%202.98C25.543%2024.527%2015.9%2019.318%209.44%2011.396c-1.125%201.936-1.77%204.184-1.77%206.58%200%204.543%202.312%208.552%205.824%2010.9-2.146-.07-4.165-.658-5.93-1.64-.002.056-.002.11-.002.163%200%206.345%204.513%2011.638%2010.504%2012.84-1.1.298-2.256.457-3.45.457-.845%200-1.666-.078-2.464-.23%201.667%205.2%206.5%208.985%2012.23%209.09-4.482%203.51-10.13%205.605-16.26%205.605-1.055%200-2.096-.06-3.122-.184%205.794%203.717%2012.676%205.882%2020.067%205.882%2024.083%200%2037.25-19.95%2037.25-37.25%200-.565-.013-1.133-.038-1.693%202.558-1.847%204.778-4.15%206.532-6.774z%22%2F%3E%3C%2Fsvg%3E);
  }
  #tweetButton span {
    position: relative;
    left: 5px;
  }

  .whatsapp-old{
    height: 28px;
    width: 77px;
    padding: 5px 0px;

    border-radius: 5px;
    background: #1DC143;
    color: white !important;
    text-shadow: 0 0 1px rgba(0,0,0,0.2);
  }
  .whatsapp-old img {
    position: relative;
    top: -2px;
    left: 2px;
  }
  .whatsapp-old span {
    position: relative;
    top: -7.5px;
    left: 5px;

    font-size: 13px;
  }
</style>
